// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file options.proto (package org.callistovault.v2, syntax proto3)
/* eslint-disable */

import type { GenExtension, GenFile } from "@bufbuild/protobuf/codegenv2";
import { extDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";
import type { MethodOptions } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_descriptor } from "@bufbuild/protobuf/wkt";

/**
 * Describes the file options.proto.
 */
export const file_options: GenFile = /*@__PURE__*/
  fileDesc("Cg1vcHRpb25zLnByb3RvEhRvcmcuY2FsbGlzdG92YXVsdC52Mjo5Cgdub19hdXRoEh4uZ29vZ2xlLnByb3RvYnVmLk1ldGhvZE9wdGlvbnMY0YYDIAEoCFIGbm9BdXRoOmAKHFhYWF9USElOS19DQVJFRlVMTFlfbm9fdG9rZW4SHi5nb29nbGUucHJvdG9idWYuTWV0aG9kT3B0aW9ucxjShgMgASgIUhhYWFhUSElOS0NBUkVGVUxMWU5vVG9rZW5CGVoXY2FsbGlzdG92YXVsdC5vcmcvcHJvdG9iBnByb3RvMw", [file_google_protobuf_descriptor]);

/**
 * @generated from extension: bool no_auth = 50001;
 */
export const no_auth: GenExtension<MethodOptions, boolean> = /*@__PURE__*/
  extDesc(file_options, 0);

/**
 * @generated from extension: bool XXX_THINK_CAREFULLY_no_token = 50002;
 */
export const XXX_THINK_CAREFULLY_no_token: GenExtension<MethodOptions, boolean> = /*@__PURE__*/
  extDesc(file_options, 1);

